import {Wrapper,Button} from "../../components";
import AboutImg from "../../assets/aboutImg.png";
import { TiTick } from "react-icons/ti";

function About(){
    const features = [
        "7/24 Müşteri Desteği",
        "Güvenli ve Hızlı İşlemler",
        "Düşük Komisyon Oranları",
        "Kullanıcı Dostu Arayüz",
        "Mobil Uygulama Desteği",
        "Anlık Fiyat Takibi"
    ];
    
    return(
        <Wrapper>
            <div className="py-24 grid grid-cols-12 gap-8 relative">
                {/* Dekoratif elementler */}
                <div className="absolute top-1/4 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -z-10"></div>
                <div className="absolute bottom-1/4 right-0 w-48 h-48 bg-primary/5 rounded-full blur-2xl -z-10"></div>
                
                <div className="md:col-start-1 md:col-end-7 col-start-1 col-end-13 hidden md:block relative">
                    <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 to-transparent rounded-2xl blur-xl"></div>
                    <div className="relative bg-dark-backgroundOnDark/30 backdrop-blur-sm p-4 rounded-2xl border border-dark-line/30 overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/10 rounded-full blur-xl"></div>
                        <img className="w-full rounded-xl relative z-10 transform hover:scale-[1.02] transition-transform duration-700" src={AboutImg} alt="GMS Kripto Platform"/>
                    </div>
                </div>
                
                <div className="md:col-start-8 md:col-end-13 col-start-1 col-end-13">
                    <div className="bg-dark-backgroundOnDark/30 backdrop-blur-sm p-8 rounded-2xl border border-dark-line/30 h-full">
                        <div className="inline-flex items-center bg-dark-background/80 rounded-full py-1.5 px-4 mb-6">
                            <span className="text-primary text-sm font-medium">GMSKripto Avantajları</span>
                        </div>
                        
                        <h2 className="font-dmsans font-bold text-3xl md:text-4xl text-surface-main mb-4">Artık Çok Kolay!</h2>
                        <p className="font-dmsans text-lg text-secondaryTwo mb-8">
                            GMS Kripto, çeşitli kripto para işlemlerini kolay ve güvenli bir şekilde yapmanızı sağlar. 
                            Modern arayüzü ve gelişmiş güvenlik özellikleriyle kripto dünyasında güvenle işlem yapın.
                        </p>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                            {features.map((feature, index) => (
                                <div key={index} className="flex items-center gap-3">
                                    <div className="bg-primary/20 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0">
                                        <TiTick className="text-primary text-lg" />
                                    </div>
                                    <p className="text-white">{feature}</p>
                                </div>
                            ))}
                        </div>
                        
                        <Button 
                            onClick={() => window.location.href = `https://exchange.gmskripto.com/signup`}
                            className="py-3 px-8 text-base bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary shadow-lg shadow-primary/20 border-none"
                        >
                            Hemen Üye Ol
                        </Button>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export {About}
